module.exports = __webpack_public_path__ + "static/bizzocchi-autel-195cl-3848908632b8e88a721da22eb7c39270.jpg";